import React from "react";
import { Divider, Flex, Button, Modal, Spin } from "antd";
import queryString from 'query-string';
import GlobalSpinLoading from "../../components/global-loading";
import { detectScreen } from '../../utils/device';

const screen = detectScreen();

const PageTitle = {
    wxopen_service: '微信服务号信息',
    wxopen_mini: '微信小程序信息',
}
export default () => {
    const [detail, setDetail] = React.useState({});
    const [loading, setLoading] = React.useState(false);
    const [path, params] = window.location.href.split('?')
    const paramsObj = queryString.parse(params || '') || {};
    React.useEffect(() => {
        getDetail().then(res => {
            console.log(res);
            setDetail(res);
        });
    }, []);
    const getDetail = async () => {
        const response = await fetch(`/api/channel/oauth/detail?type=${paramsObj.type}`);
        const result = await response.json();

        if(result?.success) {
            return result.data;
        }
        return {};
    }
    async function initTemplate() {
        setLoading(true);
        const response = await fetch(`/api/wxservice/initTemplate`);
        const result = await response.json();
        const {
            success, data = []
        } = result;
        let title = '';
        const successTextList = [];
        const errorTextList = [];
        let successType = '';
        let allSuccess = true;
        let hasSuccess = false;

        data.forEach(item => {
            allSuccess = allSuccess && item.success;
            hasSuccess = hasSuccess || item.success;
            const text = `${item?.template?.type} ${item.success ? '成功' : ('失败' + item?.content?.errmsg)}`;
            if (!item.success) {
                errorTextList.push(text);
            } else {
                successTextList.push(text);
            }
        });

        if (allSuccess) {
            successType = 'all';
            title = '全部初始化成功';
        } else {
            if (hasSuccess) {
                successType = 'part'
                title = '部分失败';
            } else {
                successType = 'fail'
                title = '全部失败';
            }
        }
        setLoading(false);
        Modal.info({
            title,
            content: (
            <div>
                <div style={{color: 'red'}}>
                {
                    errorTextList.map(item => {
                        <p>{item}</p>
                    })
                }
                </div>
                <div style={{marginTop: 16}}>
                {
                    successTextList.map(item => {
                        <p>{item}</p>
                    })
                }
                </div>
                
            </div>
            ),
            onOk() {},
        });
    }

    return (
        <div>
            <h2 className="admin-page-title">{PageTitle[paramsObj.type]}</h2>
            
            <div className="bg-white border border-gray-200 rounded-lg p-6 mb-4">
                {/* 基本信息 */}
                <div className="flex items-center gap-3 mb-4">
                    <img src={detail?.head_image_info?.head_image_url} className="w-8 h-8 rounded" alt="头像" />
                    <span className="text-lg font-medium">{detail.nickname}</span>
                </div>
                
                <div className="space-y-2 text-sm">
                    <div><span className="text-gray-500">appId:</span> <span className="ml-2">{detail.appid}</span></div>
                    <div><span className="text-gray-500">主体名称:</span> <span className="ml-2">{detail.principal_name}</span></div>
                </div>
            </div>
            
            {/* 二维码 */}
            <div className="bg-white border border-gray-200 rounded-lg p-6 mb-4">
                <div className="mb-2 text-sm text-gray-600">二维码</div>
                <img src={`https://img.yxdj.tech/${detail.erCode}`} className="w-48 h-48" alt="二维码" />
            </div>
            
            {/* 操作按钮 */}
            <div className="flex gap-3">
                <Button href={`/wxopen/oauth?type=${paramsObj.type}&pageType=${screen}`}>重新授权</Button>
                {
                    paramsObj.type === 'wxopen_service' && (
                        <Button onClick={initTemplate}>初始化消息模版</Button>
                    )
                }
            </div>
            
            <GlobalSpinLoading visible={loading} />
        </div>
    )
}